import { useLocation } from 'react-router';
import { NAV_PATH } from '@/router/constants';

const SkipNav = () => {
	// 현재 경로를 확인
	const location = useLocation();

	// 경로가 '/'일 경우 isMainPage를 true로 설정
	const isMain = location.pathname === NAV_PATH.HOME;

	return (
		<div className="skip-nav">
			<a href={isMain ? '#main' : '#sub'}>컨텐츠 바로가기</a>
		</div>
	);
};

export default SkipNav;
